import { useListUpgradeTemplatesInfinite } from 'api/frontend-infinite';
import { UPGRADE_TEMPLATES } from 'src/data/upgrades';
import { flattenPages } from 'utils/arrays';

export function useTemplateIdToNameMap({
  token,
  useExampleData,
}: {
  token: string;
  useExampleData: boolean;
}): Map<string, string> {
  const { data: rawUpgradeTemplatesData } = useListUpgradeTemplatesInfinite(
    {},
    {
      request: { headers: { Authorization: `Bearer ${token}` } },
      swr: {
        enabled: !!token,
      },
    },
  );
  const upgradeTemplates = flattenPages(rawUpgradeTemplatesData);

  return new Map(
    (useExampleData ? UPGRADE_TEMPLATES : upgradeTemplates || []).map((t) => [
      t.id,
      t.name || '',
    ]),
  );
}
